/**
 * Функция для правильного склонения слова "подписка" в зависимости от количества
 * @param count - количество подписок
 * @returns правильно склоненное слово
 */
export function pluralizeSubscriptions(count: number): string {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  // Для чисел от 11 до 14 используется форма множественного числа "подписок"
  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return 'подписок';
  }

  // Для чисел, оканчивающихся на 1 - "подписка"
  if (lastDigit === 1) {
    return 'подписка';
  }

  // Для чисел, оканчивающихся на 2, 3, 4 - "подписки"
  if (lastDigit >= 2 && lastDigit <= 4) {
    return 'подписки';
  }

  // Для всех остальных случаев - "подписок"
  return 'подписок';
}

/**
 * Функция для формирования полной фразы с количеством и правильным склонением
 * @param count - количество подписок
 * @returns строка вида "У вас X подписка/подписки/подписок"
 */
export function formatSubscriptionCount(count: number): string {
  const pluralizedWord = pluralizeSubscriptions(count);
  return `У вас ${count} ${pluralizedWord}`;
}
